import React from "react";
import { AppBar, Toolbar, Typography, Button, Box, Container } from "@mui/material";

export default function Layout({ title, onLogout, children }) {
  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            HealthLink Dashboard
          </Typography>
          <Button color="inherit" onClick={onLogout}>Logout</Button>
        </Toolbar>
      </AppBar>

      <Container sx={{ mt: 4 }}>
        <Typography variant="h5" gutterBottom>{title}</Typography>
        <Box>{children}</Box>
      </Container>
    </>
  );
}
